import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailIcon from "@mui/icons-material/Email";

import MKTypography from "components/MKTypography";

import logo from "assets/images/Spechs_logo/logo_no_text_transparent.png";

import propertyRoutes from "routes/property";
import cleaningRoutes from "routes/cleaning";

const getFooterMenus = (menu) => {
  if (menu.collapse) {
    return {
      name: menu.name,
      items: menu.collapse.map((subRoute) => getFooterMenus(subRoute)),
    };
  }
  return { name: menu.name, route: menu.route };
};

const makeSocials = ({
  facebookUrl,
  instagramUrl,
  whatsappNumber,
  email,
  emailSubject,
  emailBody,
}) => [
  { icon: <FacebookIcon />, link: facebookUrl },
  { icon: <InstagramIcon />, link: instagramUrl },
  { icon: <WhatsAppIcon />, link: `https://wa.me/${whatsappNumber}` },
  {
    icon: <EmailIcon />,
    email,
    subject: emailSubject,
    body: emailBody,
  },
];

const copyright = (
  <MKTypography variant="button" fontWeight="regular">
    Copyright &copy; {new Date().getFullYear()} Spechs. All rights reserved.
  </MKTypography>
);

export const propertyFooterRoutes = {
  company: { name: "Spechs Property Services", image: logo, route: "/" },
  socials: makeSocials({
    facebookUrl: "https://www.facebook.com/spechs.ie",
    instagramUrl: "https://instagram.com/spechs_official",
    whatsappNumber: "447900929869",
    email: "info@spechs.ie",
    emailSubject: "Inquiry",
    emailBody: "Hello, I have a question about your services.",
  }),
  menus: propertyRoutes.map((route) => getFooterMenus(route)),
  copyright,
};

export const cleaningFooterRoutes = {
  company: { name: "Spechs Cleaning Services", image: logo, route: "/" },
  socials: makeSocials({
    facebookUrl: "https://www.facebook.com/spechs.ie",
    instagramUrl: "https://instagram.com/spechs_official",
    whatsappNumber: "447900929869",
    email: "info@spechs.ie",
    emailSubject: "Cleaning Inquiry",
    emailBody: "Hello, I have a question about your cleaning services.",
  }),
  menus: cleaningRoutes.map((route) => getFooterMenus(route)),
  copyright,
};

export const suppliesFooterRoutes = {
  company: { name: "Spechs Supplies", image: logo, route: "/" },
  socials: makeSocials({
    facebookUrl: "https://www.facebook.com/spechs.ie",
    instagramUrl: "https://instagram.com/spechs_official",
    whatsappNumber: "447900929869",
    email: "info@spechs.ie",
    emailSubject: "Supplies Inquiry",
    emailBody: "Hello, I have a question about your supplies.",
  }),
  menus: [],
  copyright,
};

export const workforceFooterRoutes = {
  company: { name: "Spechs Workforce", image: logo, route: "/workforce/" },
  socials: makeSocials({
    facebookUrl: "https://www.facebook.com/spechs.ie",
    instagramUrl: "https://instagram.com/spechs_official",
    whatsappNumber: "447900929869",
    email: "admin@spechs.ie",
    emailSubject: "Spechs Workforce Enquiry",
    emailBody: "Hello, I would like to learn more about Spechs Workforce.",
  }),
  menus: [],
  copyright,
};
